// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3t-kg","range":"MonthRangeSwitch_range__35sO5","disabled":"MonthRangeSwitch_disabled__1XQep"};